import PageShell from "../components/common/PageShell";
import { useAuth } from "../context/AuthContext";
import { inr, walletTotal } from "../utils/format";

// User: GET /user/profile (memory me). Wallet: localStorage "wallet" + profile se refresh.
export default function Profile() {
  const { user, wallet: w } = useAuth();
  const wallet = w || {};

  const walletItems = [
    ["Deposit balance", wallet.depositBalance, true],
    ["Winning balance", wallet.winningBalance, true],
    ["Bonus", wallet.bonusBalance],
    ["Cashback", wallet.cashbackBalance],
    ["Referral earning", wallet.referralEarning],
    ["Locked", wallet.lockedBalance],
  ];

  return (
    <PageShell title="My Profile">
      <section className="pg-card pg-hero">
        <div className="pg-avatar">
          {(user?.username || "P")[0].toUpperCase()}
        </div>
        <div>
          <h2>{user?.username || "Player"}</h2>
          <span className="pg-muted">{user?.userId}</span>
          <div>
            <span className="pg-vip">{user?.vipLevel || "VIP0"}</span>
          </div>
        </div>
      </section>

      <section className="pg-card pg-balance-card">
        <span className="pg-muted">Total balance</span>
        <div className="pg-balance">{inr(walletTotal(wallet))}</div>
      </section>

      <section className="pg-card">
        <h2>Wallet</h2>
        <div className="pg-wallet">
          {walletItems.map(([k, v, hi]) => (
            <div className="pg-stat" key={k}>
              <span className="pg-muted">{k}</span>
              <b className={hi ? "pg-win" : ""}>{inr(v)}</b>
            </div>
          ))}
        </div>
      </section>

      <section className="pg-card">
        <h2>Account details</h2>
        <div className="pg-row">
          <span>Mobile</span>
          <b>{user?.mobile || "-"}</b>
        </div>
        <div className="pg-row">
          <span>Referral code</span>
          <b>{user?.referralCode || "-"}</b>
        </div>
        <div className="pg-row">
          <span>Status</span>
          <b className="pg-win">{user?.status || "-"}</b>
        </div>
        <div className="pg-row">
          <span>Joined</span>
          <b>
            {user?.createdAt
              ? new Date(user.createdAt).toLocaleDateString("en-IN")
              : "-"}
          </b>
        </div>
      </section>
    </PageShell>
  );
}
